const conversationFlow = {
  initial: {
    question: "How can I help you today?",
    options: [
      {
        text: "📚 Know more about CTB",
        nextId: "aboutctb",
      },
      // {
      //   text: "🌱 Learn about Coaching Programs",
      //   nextId: "programs",
      // },
      {
        text: "🎓 Understand ICF Certifications",
        nextId: "certifications",
      },
      {
        text: "🧭 Get a Personalized Recommendation",
        nextId: "recommendation",
      },
      {
        text: "📞 Contact a Program Advisor",
        nextId: "contact",
      },
    ],
  },
  certifications: {
    question: "What would you like to know about ICF Certifications?",
    options: [
      { text: "❓ What is ICF and its benefits?", nextId: "icfBenefits" },
      {
        text: "📋 What does the certification involve?",
        nextId: "icfInvolves",
      },
      { text: "💰 Cost and payment options", nextId: "icfCost" },
      { text: "📚 Available Programs", nextId: "icfPrograms" },
      { text: "📝 How to enroll?", nextId: "icfEnroll" },
      { text: "📞 Contact a Certification Advisor", nextId: "contact" },
      { text: "🔙 Back to Main Menu", nextId: "initial" },
    ],
  },
  icfBenefits: {
    question:
      "The International Coaching Federation (ICF) is a globally recognized organization for coaching professionals. <br><br> ICF certification demonstrates your credibility, enhances your coaching skills, and opens doors to international opportunities. Would you like to know more?",
    options: [
      {
        text: "🔗 Learn more on the official ICF website",
        link: "https://coachingfederation.org/",
      },
      {
        text: "💬 Chat with a Adviser on WhatsApp",
        link: "https://wa.me/9929468148?text=I%20would%20like%20to%20know%20more%20about%20ICF%20and%20Benifits%20of%20ICF",
      },
      { text: "🔙 Back To Menu", nextId: "certifications" },
    ],
  },
  icfInvolves: {
    question:
      "ICF certification involves completing an accredited training program, logging coaching hours, and passing an assessment. <br><br> The process ensures you meet high standards of coaching excellence. Need details on specific requirements?",
    options: [
      {
        text: "💬 Chat with a adviser on WhatsApp",
        link: "https://wa.me/9929468148?text=I%20would%20like%20to%20know%20more%20about%20what%20ICF%20Certification%20Involves",
      },
      { text: "🔙 Back To Menu", nextId: "certifications" },
    ],
  },
  icfCost: {
    question:
      "The cost of ICF certification varies by program and level. Payment plans and scholarships may be available. Would you like to see program-specific costs or speak to an advisor?",
    options: [
      {
        text: "💬 Chat with a adviser on WhatsApp",
        link: "https://wa.me/9929468148?text=Hi%2C%20I%27d%20like%20to%20learn%20more%20about%20the%20cost%20and%20payment%20options%20for%20your%20coaching%20programs.",
      },
      { text: "🔙 Back To Menu", nextId: "certifications" },
    ],
  },
  icfPrograms: {
    question:
      "We offer several ICF-accredited programs tailored to different experience levels. Would you like a personalized recommendation or browse all programs?",
    options: [
      {
        text: "👤 Individual Coaching Program",
        nextId: "individualCoachingProgram",
      },
      {
        text: "🏢 Organizational Coaching Program",
        nextId: "organizationalCoachingProgram",
      },
      { text: "🔙 Back To Menu", nextId: "certifications" },
    ],
  },
  icfEnroll: {
    question:
      "To enroll, simply choose your preferred program and complete the online application. <br><br> Our advisors are available to guide you through the process. Would you like to start your application now?",
    options: [
      {
        text: "💬 Chat with a adviser to Enroll",
        link: "https://wa.me/9929468148?text=Hi%2C%20I%27m%20interested%20in%20enrolling%20in%20a%20coaching%20program.%20Can%20you%20help%20me%20get%20started%3F",
      },
      { text: "🔙 Back To Menu", nextId: "certifications" },
    ],
  },
  contact: {
    question:
      "You can contact a program advisor directly by phone or email. Would you like to speak with one now?",
    options: [
      { text: "📞 Call a Program Advisor", link: "tel:+919819926379" },
      {
        text: "📧 Email a Program Advisor",
        link: "mailto:crm@cometobecoaching.com",
      },
      {
        text: "💬 Chat with a adviser on WhatsApp",
        link: "https://wa.me/9929468148?text=I%20would%20like%20to%20know%20more%20about%20coaching%20programs",
      },
      { text: "🔙 Back To Menu", nextId: "initial" },
    ],
  },
  individualCoachingProgram: {
    question:
      "The Individual Coaching Program is designed for individuals seeking personal growth and development. <br><br> It covers various areas such as personal development, relationship management, and career coaching. Would you like to learn more about this program?",
    options: [
      {
        text: "💬 Chat with a adviser on WhatsApp",
        link: "https://wa.me/9929468148?text=Hi%2C%20I%27m%20interested%20in%20your%20Individual%20Coaching%20Program.%20Can%20you%20tell%20me%20more%20about%20it%3F",
      },
      { text: "🔙 Back To Menu", nextId: "icfPrograms" },
    ],
  },
  organizationalCoachingProgram: {
    question:
      "The Organizational Coaching Program is tailored for businesses and organizations seeking to enhance their internal teams' performance and effectiveness. <br><br> It covers areas such as leadership development, team building, and communication skills. Would you like to learn more about this program?",
    options: [
      {
        text: "💬 Chat with a adviser on WhatsApp",
        link: "https://wa.me/9929468148?text=Hi%2C%20I%27d%20like%20to%20know%20more%20about%20your%20Organizational%20Coaching%20Program.",
      },
      { text: "🔙 Back To Menu", nextId: "icfPrograms" },
    ],
  },
  aboutctb: {
    question:
      "CTB talent development services LLP is a leading coaching institute dedicated to helping individuals and organizations achieve their goals. <br><br> We offer a wide range of coaching programs and certifications to cater to different needs. Would you like to learn more?",
    options: [
      { text: "ℹ️ About Us", nextId: "aboutus" },
      { text: "📖 Our Story", nextId: "ourstory" },
      { text: "🎯 Our Mission", nextId: "ourmission" },
      { text: "✨ Why Choose CTB?", nextId: "whychoosectb" },
      { text: "🔙 Back to Main Menu", nextId: "initial" },
    ],
  },
  aboutus: {
    question:
      "At CTB talent development services LLP, we're dedicated to helping you unlock your true potential and achieve the goals that matter most to you. <br><br> As a team of ICF certified coaches, we offer tailored, one-on-one coaching sessions designed to guide you through life’s challenges, helping you grow and thrive. <br><br> Whether you're seeking personal development, career growth, or improved well-being, we’ll work together to create a roadmap to success and build a life you truly love.",
    options: [{ text: "🔙 Back to Main Menu", nextId: "aboutctb" }],
  },
  ourstory: {
    question:
      "CTB was born out of a passion for helping individuals and organisations thrive. <br><br> Founded in 2016 by Mr.Sunil Verma MCC, with a background in learning and development , we recognised the transformative power of coaching and its potential to unlock exceptional results. <br><br> Over the years, we've grown into a leading provider of coaching and facilitation services across South Asia, with a team of experienced coaches dedicated to your success.",
    options: [{ text: "🔙 Back to Main Menu", nextId: "aboutctb" }],
  },
  whychoosectb: {
    question: `<b>ICF-Accredited Coaches: </b>Our coaches are credentialed by the International Coaching Federation (ICF), the gold standard in the coaching industry, ensuring you receive the highest quality coaching available.
<br><br><b>Data-Driven Results: </b>We are committed to providing measurable outcomes. Our coaching programs are grounded in evidence-based practices and designed to achieve your specific goals.
<br><br><b>Bespoke Solutions: </b>We take a personalized approach, tailoring our coaching programs to your unique needs and objectives.
<br><br><b>Experienced Team: </b>Our team consists of highly experienced coaches with diverse backgrounds and a passion for helping you succeed.`,
    options: [{ text: "🔙 Back to Main Menu", nextId: "aboutctb" }],
  },
  ourmission: {
    question: `<b>Our Mission: </b>To offer coaching and mentorship that inspires self-discovery, builds confidence, and provides tools for personal and professional success.
    <br><br><b>Our Vision: </b>To empower individuals to overcome challenges, unlock their potential, and thrive with purpose and fulfillment.
    <br><br><b>Our Goal: </b>To empower individuals to unlock their full potential, achieve personal growth, and foster a meaningful, fulfilling life journey.`,
    options: [{ text: "🔙 Back to Main Menu", nextId: "aboutctb" }],
  },
  recommendation: {
    question:
      "Let’s find the best coaching program for you. Just a few quick questions to get started!",
    options: [
      { text: "➡️ Start Now", nextId: "q1_experience" },
      { text: "🔙 Back to Main Menu", nextId: "initial" },
    ],
  },
  q1_experience: {
    question: "Are you new to coaching, or do you already have experience?",
    options: [
      { text: "🆕 I'm new to coaching", nextId: "q2_focus" },
      { text: "✅ I have some coaching experience", nextId: "q2_focus" },
    ],
  },
  q2_focus: {
    question: "What kind of coaching are you most interested in?",
    options: [
      { text: "👔 Career Coaching", nextId: "q3_commitment" },
      { text: "💖 Life Coaching", nextId: "q3_commitment" },
      { text: "📈 Business or Executive Coaching", nextId: "q3_commitment" },
      { text: "🧠 Leadership Coaching", nextId: "q3_commitment" },
      { text: "🤔 I'm not sure yet", nextId: "q3_commitment" },
    ],
  },
  q3_commitment: {
    question: "How much time can you commit to training per week?",
    options: [
      { text: "🕒 Less than 5 hours/week", nextId: "q4_goal" },
      { text: "⏰ 5–10 hours/week", nextId: "q4_goal" },
      { text: "🗓️ More than 10 hours/week", nextId: "q4_goal" },
    ],
  },
  q4_goal: {
    question: "Is your goal to become an ICF-certified coach?",
    options: [
      {
        text: "🎓 Yes, I want to be certified (ACC or PCC)",
        nextId: "result_cert",
      },
      {
        text: "🧘‍♀️ I'm more interested in self-growth",
        nextId: "result_noncert",
      },
      { text: "❓ I'm not sure yet", nextId: "result_explore" },
    ],
  },
  result_cert: {
    question:
      "Based on your answers, we recommend one of our ICF-certified programs:<br><br>Level 1 (ACC) – Great for beginners<br>Level 2 (PCC) – Ideal for experienced coaches<br><br>Would you like to explore the programs now?",
    options: [
      { text: "📚 Show ICF Programs", nextId: "icfPrograms" },
      { text: "📞 Talk to a Program Advisor", nextId: "contact" },
      { text: "🔙 Back to Main Menu", nextId: "initial" },
    ],
  },
  result_noncert: {
    question:
      "You may enjoy our Life Coaching or Career Coaching programs. These are designed for self-development and helping others without needing ICF certification.\n\nWould you like to explore them?",
    options: [
      // { text: "🌱 Explore Life Coaching", nextId: "lifeCoaching" },
      // { text: "🚀 Explore Career Coaching", nextId: "careerCoaching" },
      { text: "📞 Talk to a Program Advisor", nextId: "contact" },
      { text: "🔙 Back to Main Menu", nextId: "initial" },
    ],
  },
  result_explore: {
    question:
      "No worries! Many students start without being 100% sure. You can explore different programs or talk to an advisor to get more clarity.",
    options: [
      { text: "📚 Show All Programs", nextId: "icfPrograms" },
      { text: "📞 Talk to a Program Advisor", nextId: "contact" },
      { text: "🔙 Back to Main Menu", nextId: "initial" },
    ],
  },
};

export default conversationFlow;